<div class="AppAlert">
  <div class="alert alert-warning alert-dismissible fade show" role="alert">
    {{mensaje}}
    <button *ngIf="close" type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span >&times;</span>
    </button>
  </div>

</div>
